import { render, staticRenderFns } from "./TrackDetails.vue?vue&type=template&id=35208182"
import script from "./TrackDetails.vue?vue&type=script&lang=js"
export * from "./TrackDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports